/* Ventra collections: endless scrolling. The next page's products are added under the current ones as the
   shopper nears the end. Filters, sorting and browsing shortcuts keep working; the page links stay in the
   page (hidden) for search engines and as a fallback. */
(() => {
  if (window.ventraCollectionPlus) return;
  window.ventraCollectionPlus = true;
  const pageOf = href => { try { return Number(new URL(href, location.origin).searchParams.get('page')) || 1; } catch { return 1; } };
  const announce = (shop, text) => { const node = shop.querySelector('[data-catalog-status]') || document.querySelector('[data-vfm-status]'); if (node) node.textContent = text; };

  function setup(shop) {
    if (!shop || shop.dataset.vfcInfinite) return;
    if (new URL(location.href).searchParams.get('vfc_topic')) return;
    const region = shop.querySelector('.vs-grid-region');
    const grid = region && region.querySelector('.vs-product-grid');
    const nav = region && region.querySelector('.vs-pagination');
    if (!grid || !nav || nav.querySelector('button')) return;
    const current = Number(nav.querySelector('[aria-current="page"]')?.textContent) || pageOf(location.href);
    const last = Math.max(current, ...[...nav.querySelectorAll('a[href]')].map(link => pageOf(link.href)));
    if (last <= current) return;
    shop.dataset.vfcInfinite = 'true';
    nav.hidden = true;

    let page = current, loading = false, done = false, observer = null;
    const seen = new Set([...grid.querySelectorAll('[data-product-id]')].map(node => node.dataset.productId));
    const more = document.createElement('div');
    more.className = 'vfc-more';
    const status = document.createElement('p');
    status.className = 'vfc-more-status';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'vfc-more-btn';
    button.textContent = 'Show more finds';
    more.append(status, button);
    nav.after(more);

    const finish = () => {
      done = true;
      if (observer) observer.disconnect();
      button.remove();
      status.textContent = "You've seen every find here.";
      more.classList.add('is-done');
    };

    async function load() {
      if (loading || done || !shop.isConnected) return;
      if (shop.topic) { if (observer) observer.disconnect(); more.remove(); return; }
      loading = true;
      more.classList.add('is-loading');
      button.disabled = true;
      status.textContent = 'Loading more finds…';
      const url = new URL(location.href);
      url.hash = '';
      url.searchParams.delete('vfc_topic');
      url.searchParams.set('page', String(page + 1));
      url.searchParams.set('section_id', shop.dataset.section);
      try {
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!shop.isConnected) return;
        const items = [...doc.querySelectorAll('.vs-product-grid > li')];
        let added = 0;
        items.forEach(item => {
          const id = item.querySelector('[data-product-id]')?.dataset.productId;
          if (id && seen.has(id)) return;
          if (id) seen.add(id);
          grid.append(document.importNode(item, true));
          added += 1;
        });
        page += 1;
        if (typeof shop.syncSaved === 'function') shop.syncSaved();
        status.textContent = '';
        if (added) announce(shop, added === 1 ? '1 more find added.' : `${added} more finds added.`);
        if (page >= last || !items.length) finish();
      } catch (error) {
        status.textContent = "More finds couldn't load. Try again.";
      } finally {
        loading = false;
        more.classList.remove('is-loading');
        if (!done) {
          button.disabled = false;
          if (observer) { observer.unobserve(more); observer.observe(more); }
        }
      }
    }

    button.addEventListener('click', load);
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) load(); }, { rootMargin: '0px 0px 900px 0px' });
      observer.observe(more);
    }
  }

  const scan = () => document.querySelectorAll('ventra-shop').forEach(setup);
  const start = () => {
    scan();
    new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches('ventra-shop')) setup(node);
          else node.querySelectorAll?.('ventra-shop').forEach(setup);
        }
      }
    }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  };
  if (window.customElements && customElements.whenDefined) customElements.whenDefined('ventra-shop').then(start);
  else start();
})();
